<template>
    <div class="row">
       <div class="mx-auto col-md-12">               
            <div class="card p-3 mb-3">
                <div class="card-body">
                    <b-card
                        class="mb-2"
                        header="Arquivo para busca de contas"
                        header-tag="header">
                        <div class="p-0 row mb-3">                
                            <div class="col-12 text-center">
                                <b-button            
                                    @click="exportarTxt"                                                                                                    
                                    variant="primary" >
                                        <font-awesome-icon                                                                      
                                            :icon="['fas','file-download']"
                                            class="mr-1"
                                        />
                                        Exportar para CSV
                                </b-button> 
                            </div>
                        </div> 
                    </b-card>           
                </div>
            </div>            
       </div>
    </div>
</template>

<script>

export default {
    methods: {
        exportarTxt(){   
            this.$api.get(`familias/exportar/familias-sem-conta`, {responseType: 'blob'})
                .then(response => {  
                    this.$helpers.downloadFile(response.data,'busca_de_conta.csv');
                    this.$helpers.showToast(this, 'Sucesso', 'Exportação realizada com sucesso.','success');                   
                })
                .catch( () => {                                            
                    this.$helpers.showToast(this,'Erro', 'Erro na exportação', 'danger');                                            
                }); 
        },
    },
}

</script>

<style scoped>

</style>
